import { Component, Input, OnInit } from '@angular/core';
import { UserModel } from 'src/app/shared/model/user.model';

@Component({
  selector: 'app-admin-user-item',
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.css']
})
export class AdminUserItemComponent implements OnInit {

  @Input() user!:UserModel;

  constructor() { }

  ngOnInit(): void {
  }

}
